import { createSlice } from "@reduxjs/toolkit";

import type { ChannelStatus } from "@/shared/types/channelTypes";

export type ReviewQueueRow = {
  id: number;
  name: string;
  channelCode: string;
  type: string;
  status: ChannelStatus;
  licenceValidity: string;
  userMode?: string;
  users?: number;
  lastUpdated?: string;
  recordedBy: string;
  submittedOn: string;
};

export type ReviewQueueList = {
  total: number;
  page: number;
  page_size: number;
  data: ReviewQueueRow[];
};

export type ReviewQueueState = {
  reviewQueueList: ReviewQueueList;
};

const initialState: ReviewQueueState = {
  reviewQueueList: {
    total: 4,
    page: 1,
    page_size: 10,
    data: [
      {
        id: 1,
        channelCode: "adittya",
        name: "adittya",
        type: "Bancassurance",
        userMode: "Multi-user",
        status: "Submitted",
        users: 0,
        licenceValidity: "-",
        lastUpdated: "29 Aug 2026",
        recordedBy: "kunal.app199@gmail.com",
        submittedOn: "29 Aug 2026",
      },
      {
        id: 2,
        channelCode: "IMF-4102",
        name: "Kaveri Insurance Marketing Firm",
        type: "Insurance Marketing Firm (IMF)",
        userMode: "Multi-user",
        status: "Submitted",
        users: 0,
        licenceValidity: "20 Aug 2026",
        lastUpdated: "17 Aug 2026",
        recordedBy: "Priya Menon",
        submittedOn: "17 Aug 2026",
      },
      {
        id: 3,
        channelCode: "PSP-7031",
        name: "Neha Bansal",
        type: "Point of Sales Person (PoSP)",
        userMode: "Single user",
        status: "Sent back",
        users: 0,
        licenceValidity: "30 Jun 2027",
        lastUpdated: "17 Aug 2026",
        recordedBy: "Priya Menon",
        submittedOn: "17 Aug 2026",
      },
      {
        id: 4,
        channelCode: "CAG-2004",
        name: "Vertex Retail Corporate Agency",
        type: "Corporate Agent (CA)",
        userMode: "Multi-user",
        status: "Under review",
        users: 0,
        licenceValidity: "30 Nov 2026",
        lastUpdated: "17 Aug 2026",
        recordedBy: "Vikram Shah",
        submittedOn: "17 Aug 2026",
      },
    ],
  },
};

const reviewQueueSlice = createSlice({
  name: "reviewQueue",
  initialState,
  reducers: {},
});

export const { reducer: reviewQueueReducer } = reviewQueueSlice;
export default reviewQueueReducer;
